// extracted by mini-css-extract-plugin
export default {"Section":"OfferRequests_Section__GugSa"};